// src/components/StoryList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import md5 from 'md5';
import Background from './Background';
import ButtonSec from './ButtonSec';
import Button from './Button';
import LinkButton from './LinkButton';
import Menu from './Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import Seo from './Seo';  // important!

const StoryList = () => {
  const [stories, setStories] = useState([]);
  const [visibleCount, setVisibleCount] = useState(32);
  const [offset, setOffset] = useState(0);
  const [backwardOffset, setBackwardOffset] = useState(0);
  const publicKey = process.env.REACT_APP_MARVEL_PUBLIC_KEY;
  const privateKey = process.env.REACT_APP_MARVEL_PRIVATE_KEY;
  const [copyright, setCopyright] = useState('');

  useEffect(() => {
    const timestamp = new Date().getTime();
    const hash = md5(`${timestamp}${privateKey}${publicKey}`);

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://gateway.marvel.com/v1/public/stories?orderBy=-modified&apikey=${publicKey}&ts=${timestamp}&hash=${hash}&limit=${visibleCount}&offset=${offset - backwardOffset}`
        );

        setStories(response.data.data.results);

        const copyrightText = response.data.attributionText;
        setCopyright(copyrightText);
      } catch (error) {
        console.error('Error fetching stories:', error);
      }
    };

    fetchData();
  }, [privateKey, publicKey, visibleCount, offset, backwardOffset]);

  const handleShowMore = () => {
    setOffset((prevOffset) => prevOffset + visibleCount);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleShowLess = () => {
    setBackwardOffset((prevBackwardOffset) => (prevBackwardOffset + visibleCount <= offset ? prevBackwardOffset + visibleCount : 0));
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const totalPages = Math.ceil(stories.length / visibleCount);
  const currentPage = Math.ceil((offset - backwardOffset) / visibleCount) + 1;

  if (!stories) {
    return (
    <Background>
      <div className='flex flex-col p-4'>
        <div className='flex flex-col mb-2'>
            <LinkButton to="/stories">
            <Button>Back to list</Button>
            </LinkButton>
        </div>
      </div>
    </Background>
    );
  }

  return (
    <Background>
      <div className="flex flex-col">
      <Menu textVariable='Marvel Stories' />
          <Seo 
            title='Stories list'
            description='Characters, stories, events, comics and more.'
            type='article'
            image_link='/images/logo/mv_app_logo.png'
            keywords='mv-app, mvapp'
            url=''
          />
        <ul className="divide-y divide-slate-100">


        {stories.length > 0 ? (
          stories.map((story) => (
            <li className="py-4" key={story.id}>
              <div className='flex overflow-hidden'>
                <div className="w-full mb-2">
                  <p className="text-2xl font-medium text-slate-100"><FontAwesomeIcon icon={faCaretRight}/>&emsp;{story.originalIssue.name}</p>
                  <p className="text-l text-slate-50">Description: {story.title}</p>
                  <p className="text-l text-slate-50 truncate">Original issue: {story.originalIssue.name}</p>
                  <p className='text-l text-slate-100'>Comics available: {story.comics.available} / Series available: {story.series.available}</p>
                  <p className='text-l text-slate-100'>Creators available: {story.creators.available} / Events available: {story.events.available}</p>
                  <p className='text-l text-slate-200'>Modified: {story.modified}</p>
                  <LinkButton to={`/story/${story.id}`}><Button>More about story</Button></LinkButton>
                </div>
              </div>
            </li>
          ))
        )  : (
          <li className='py-4'>
            <div className='flex justify-center items-center'>
              <img className='w-48 items-center' src="/images/logo/loading-29.gif" alt="loading-29"/>
            </div>
          </li>
        )}
        </ul>
        <div className='flex flex-row justify-center items-center py-4'>
            <div className='text-xl text-slate-100'><FontAwesomeIcon onClick={handleShowLess} icon={faCaretLeft}/>&emsp;Navigation - Page {currentPage}&emsp;<FontAwesomeIcon onClick={handleShowMore} icon={faCaretRight}/></div>
          </div>
          <div className='flex flex-row justify-center'>
            <div className='flex-basis-2/4 mb-2'><ButtonSec onClick={handleShowLess}>Previous</ButtonSec></div>
            <div className='flex-basis-2/4 mb-2'><ButtonSec onClick={handleShowMore}>Next</ButtonSec></div>
          </div>
          <div className='flex flex-row justify-center border-t border-slate-100 py-4'>
            <img src="/images/logo/mv_app_logo_mini.png" alt="mv-logo-app-mini"/>
          </div>
          <div className='flex flex-col justify-center items-center'>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>{copyright}</p></div>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>App PCh v.1.8</p></div>
          </div>
      
      </div>


    </Background>
  );
};

export default StoryList;
